(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["press-news"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('legato-newsroom')) {
    customElements.define('legato-newsroom', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const items = Array.from(this.querySelectorAll('[data-news-item]'));
        const button = this.querySelector('[data-load-more]');
        const pageSize = Math.max(1, Number(this.dataset.pageSize) || 3);
        if (!button || this.hasAttribute('data-design-mode') || items.length <= pageSize) return;
        let visibleCount = pageSize;
        const update = () => {
          items.forEach((item, index) => { item.hidden = index >= visibleCount; });
          button.hidden = visibleCount >= items.length;
        };
        button.addEventListener('click', () => {
          const firstNewItem = items[visibleCount];
          visibleCount += pageSize;
          update();
          const focusTarget = firstNewItem?.querySelector('a') || firstNewItem;
          if (focusTarget) {
            if (!focusTarget.matches('a')) focusTarget.tabIndex = -1;
            focusTarget.focus({ preventScroll: true });
          }
        });
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-newsroom"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('legato-newsroom')) {
    customElements.define('legato-newsroom', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const items = Array.from(this.querySelectorAll('[data-news-item]'));
        const button = this.querySelector('[data-load-more]');
        const pageSize = Math.max(1, Number(this.dataset.pageSize) || 3);
        if (!button || this.hasAttribute('data-design-mode') || items.length <= pageSize) return;
        let visibleCount = pageSize;
        const update = () => {
          items.forEach((item, index) => { item.hidden = index >= visibleCount; });
          button.hidden = visibleCount >= items.length;
        };
        button.addEventListener('click', () => {
          const firstNewItem = items[visibleCount];
          visibleCount += pageSize;
          update();
          const focusTarget = firstNewItem?.querySelector('a') || firstNewItem;
          if (focusTarget) {
            if (!focusTarget.matches('a')) focusTarget.tabIndex = -1;
            focusTarget.focus({ preventScroll: true });
          }
        });
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
